export default "<!-- Menu bar -->\r\n<app-menu-bar-rsvn></app-menu-bar-rsvn>"